<cdk-virtual-scroll-viewport itemSize="200" class="example-viewport cdk">
  <div>
    <h1 style="text-align: center">
      <strong>Historico orden de trabajo</strong>
    </h1>
    <h2 style="text-align: center">
      Código:{{ data.$event.code }}, Fecha:{{ data.$event.executionDate }}
    </h2>
    <h2 style="text-align: center">
      Discripcion: {{ data.$event.description }}
    </h2>

    <form
      [formGroup]="formPutOT"
      (ngSubmit)="
        formPutOT.valid ? actualizarHistorico(formPutOT.value) : errorMessage()
      "
    >
      <div class="first-row">
        <div class="row-item">
          <mat-form-field>
            <input
              autocomplete="off"
              type="number"
              matInput
              formControlName="finalTime"
              required
              #tiempo
              oninput="this.value = this.value.slice(0,2)"
              placeholder="Tiempo Final horas"
            />
            <mat-hint>{{ tiempo.value.length }}/2</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <div class="default-row">
        <div class="row-item">
          <mat-form-field>
            <input
              autocomplete="off"
              type="number"
              matInput
              formControlName="finalCost"
              required
              #costo
              oninput="this.value = this.value.slice(0,10)"
              placeholder="Costo Final"
            />
            <mat-hint>{{ costo.value.length }}/10</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <div class="default-row">
        <div class="row-item">
          <mat-form-field>
            <input
              autocomplete="off"
              type="text"
              matInput
              formControlName="observations"
              placeholder="Observaciones"
              #observaciones
              maxlength="255"
            />
            <mat-hint>{{ observaciones.value.length }}/255</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <div class="default-row">
        <div class="row-item">
          <mat-form-field>
            <input
              autocomplete="off"
              type="text"
              matInput
              formControlName="invoiceReference"
              #ref_factura
              maxlength="100"
              placeholder="Referencia Factura"
            />
            <mat-hint>{{ ref_factura.value.length }}/100</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <div class="default-row">
        <div class="row-item">
          <mat-form-field>
            <input
              autocomplete="off"
              type="number"
              matInput
              formControlName="odometer"
              #odometro
              oninput="this.value = this.value.slice(0,8)"
              placeholder="Odómetro/Horómetro"
              required
            />
            <mat-hint>{{ odometro.value.length }}/8</mat-hint>
            <mat-error>Campo requerido</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="containerPhotos">
        <div class="photo">
          <h3 style="padding: 0; margin: 0; text-align: center">Foto 1</h3>
          <file-input
            [params]="fileInput"
            (fileSave)="fileSave($event, 1)"
          ></file-input>
        </div>
        <div class="photo">
          <h3 style="padding: 0; margin: 0; text-align: center">Foto 2</h3>
          <file-input
            [params]="fileInput2"
            (fileSave)="fileSave($event, 2)"
          ></file-input>
        </div>
        <div class="photo">
          <h3 style="padding: 0; margin: 0; text-align: center">Foto 3</h3>
          <file-input
            [params]="fileInput3"
            (fileSave)="fileSave($event, 3)"
          ></file-input>
        </div>
      </div>

      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: center;
          margin-top: 30px;
        "
      >
        <button
          style="width: 60%"
          color="primary"
          class="button-save mat-elevation-z5"
          type="submit"
          mat-raised-button
        >
          Aceptar
        </button>
      </div>
    </form>
  </div>
</cdk-virtual-scroll-viewport>
